export default __webpack_public_path__ + "78a45e03686463de91ff1259d28b14b8.png";